import * as Styled from './styled'
import { IFilterDropdownProps } from '../types'
import OptionDropdown from '../OptionDropdown'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'

export const FilterDropdown = ({
  label,
  className,
  options,
  selectedValue,
  onSelect
}: IFilterDropdownProps) => {
  return (
    <Styled.DropdownContainer>
      <Styled.DropdownLabel>{label}</Styled.DropdownLabel>
      <OptionDropdown
        className={className}
        label={translate(T.ALL_LABEL)}
        options={options}
        selectedValue={selectedValue}
        onSelect={onSelect}
      />
    </Styled.DropdownContainer>
  )
}
